import { ConfluencePageAri, TownsquareGoalAri, TownsquareProjectAri } from '@atlassian/ari';

export const isPreviewPanelAvailable = ({ ari }: { ari: string }) =>
	ConfluencePageAri.check(ari) || TownsquareGoalAri.check(ari) || TownsquareProjectAri.check(ari);
